module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tasks"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-breadcrumb', {
    staticClass: "breadCrumb",
    attrs: {
      "items": _vm.breadCrumbItems
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 offset-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.filter),
      expression: "filter",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "debounce",
      rawName: "v-debounce",
      value: (500),
      expression: "500"
    }],
    attrs: {
      "placeholder": "Type to Search"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "change": function($event) {
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 offset-md-1"
  }, [_c('b-button', {
    staticClass: "button-add",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onAddTaskClick()
      }
    }
  }, [_vm._v("\n          Add task\n        ")])], 1)]), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "md",
      "total-rows": _vm.formData.filteredTask.length,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }), _vm._v(" "), _c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": _vm.processText
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table text-center border"
  }, [_c('thead', [_c('tr', {
    on: {
      "dragover": function($event) {
        return _vm.changePage(true)
      }
    }
  }, _vm._l((_vm.formData.taskFields), function(item) {
    return _c('th', {
      staticClass: "text-center align-middle"
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])
  }), 0)]), _vm._v(" "), _vm._l((_vm.formData.tasks), function(item, index) {
    return ((_vm.currentPage - 1) * _vm.perPage <= _vm.filteredIndex(_vm.formData.tasks[index]) && _vm.filteredIndex(_vm.formData.tasks[index]) < (_vm.currentPage) * _vm.perPage && _vm.isInFilter(item)) ? [(item.recurrencies.length > 0) ? [_c('tbody', {
      staticClass: "row-hover"
    }, _vm._l((item.recurrencies), function(recur, recurIndex) {
      return _c('tr', {
        attrs: {
          "draggable": _vm.authUser.role !== 'shift_leader'
        },
        on: {
          "click": function($event) {
            return _vm.onRowClick(item)
          },
          "drop": function($event) {
            return _vm.handleDrop($event, index)
          },
          "dragstart": function($event) {
            return _vm.handleDragStart($event, item, index)
          },
          "dragend": function($event) {
            return _vm.handleDragEnd($event, item, index)
          },
          "dragover": function($event) {
            return _vm.handleDragOver($event, index)
          }
        }
      }, [(recurIndex == 0) ? _c('td', {
        staticClass: "align-middle",
        attrs: {
          "rowspan": item.recurrencies.length
        }
      }, [_vm._v("\n                " + _vm._s(item.index) + "\n\n                "), (_vm.authUser.role !== 'shift_leader') ? _c('div', {
        staticClass: "btn-numeric-icn draggable",
        on: {
          "mouseover": function($event) {
            return _vm.handleBtnMouseEvent(true)
          },
          "mouseleave": function($event) {
            return _vm.handleBtnMouseEvent(false)
          }
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), (recurIndex == 0) ? _c('td', {
        staticClass: "text-left align-middle",
        attrs: {
          "rowspan": item.recurrencies.length
        }
      }, [_c('b', [_vm._v(_vm._s(item.id))])]) : _vm._e(), _vm._v(" "), (recurIndex == 0) ? _c('td', {
        staticClass: "text-left align-middle ",
        attrs: {
          "rowspan": item.recurrencies.length
        }
      }, [_c('p', [_c('b', [_vm._v("Title: ")]), _vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Description: ")]), _vm._v(_vm._s(item.description))])]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "text-left align-middle"
      }, _vm._l((_vm.getWorkingAreasListById(recur.area, _vm.areas)), function(area) {
        return _c('div', [_vm._v("\n                " + _vm._s(area ? area.name : '')), (area.id != recur.area) ? _c('span', [_vm._v("/")]) : _vm._e()])
      }), 0), _vm._v(" "), _c('td', {
        staticClass: "text-left align-middle"
      }, [(item.role) ? [_vm._v("\n                  " + _vm._s(_vm.roles[item.role]) + "\n              ")] : _vm._e()], 2), _vm._v(" "), _c('td', {
        staticClass: "text-center align-middle recurence_cell"
      }, [(recur.type == 'week') ? [_c('span', [_vm._v("By week ")]), _vm._v(" "), _c('div', [(recur.start_date) ? _c('div', [_vm._v("From " + _vm._s(recur.start_date) + " ")]) : _vm._e(), _vm._v(" "), (recur.end_date) ? _c('div', [_vm._v("To " + _vm._s(recur.end_date) + " ")]) : _vm._e()]), _vm._v(" "), _c('div', [_vm._v("Recur every " + _vm._s(recur.week) + " week")]), _vm._v(" "), (recur.is_once_per_week) ? [_c('div', [_vm._v("Once per week")])] : _vm._l((_vm.weekdays), function(weekday, key) {
        return (recur[key]) ? _c('div', [_vm._v("\n                    " + _vm._s(weekday) + "\n                  ")]) : _vm._e()
      })] : (recur.type == 'month') ? [_c('span', [_vm._v("By month")]), _vm._v(" "), (recur.start_date) ? _c('div', [_vm._v("From " + _vm._s(recur.start_date) + " ")]) : _vm._e(), _vm._v(" "), (recur.end_date) ? _c('div', [_vm._v("To " + _vm._s(recur.end_date) + " ")]) : _vm._e(), _vm._v(" "), (recur.is_once_per_month) ? [_c('div', [_vm._v("Recur every " + _vm._s(recur.month) + " month")]), _vm._v(" "), _c('div', [_vm._v("Once per month")])] : [(recur.month_recurrency == 'day_of_month') ? [_c('div', [_vm._v("Recur on " + _vm._s(recur.day) + " day of every " + _vm._s(recur.month) + " month")])] : [_c('div', [_vm._v("\n                      The " + _vm._s(_vm.getWeekNumbersItem(recur.weekday_number)) + " " + _vm._s(_vm.getDaysName(recur.weekday)) + " of every " + _vm._s(recur.month) + " month\n                    ")])]]] : (recur.type == 'shifts') ? [_c('span', [_vm._v("By shifts")]), _vm._v(" "), _c('div', [(recur.start_date) ? _c('div', [_vm._v("From " + _vm._s(recur.start_date) + " ")]) : _vm._e(), _vm._v(" "), (recur.end_date) ? _c('div', [_vm._v("To " + _vm._s(recur.end_date) + " ")]) : _vm._e()]), _vm._v(" "), _vm._l((recur.shifts), function(shift) {
        return [_c('div', [_vm._v("\n                      " + _vm._s(_vm.getShiftTime(_vm.getShiftById(shift))) + "\n                  ")])]
      })] : (recur.type == 'no recurrency') ? [_c('span', [_vm._v("One time")]), _vm._v(" "), _c('div', [_vm._v("\n                  " + _vm._s(recur.date) + "\n                ")]), _vm._v(" "), _vm._l((recur.one_time_shifts), function(shift) {
        return [_c('div', [_vm._v("\n                      " + _vm._s(_vm.getShiftTime(_vm.getShiftById(shift))) + "\n                  ")])]
      })] : [_c('span', [_vm._v(_vm._s(recur.type))])]], 2)])
    }), 0)] : [_c('tbody', {
      staticClass: "row-hover"
    }, [_c('tr', {
      attrs: {
        "draggable": _vm.authUser.role !== 'shift_leader'
      },
      on: {
        "click": function($event) {
          return _vm.onRowClick(item)
        },
        "drop": function($event) {
          return _vm.handleDrop($event, index)
        },
        "dragstart": function($event) {
          return _vm.handleDragStart($event, item, index)
        },
        "dragend": function($event) {
          return _vm.handleDragEnd($event, item, index)
        },
        "dragover": function($event) {
          return _vm.handleDragOver($event, index)
        }
      }
    }, [_c('td', {
      staticClass: "align-middle"
    }, [_vm._v("\n              " + _vm._s(item.index) + "\n              "), (_vm.authUser.role !== 'shift_leader') ? _c('div', {
      staticClass: "btn-numeric-icn draggable",
      on: {
        "mouseover": function($event) {
          return _vm.handleBtnMouseEvent(true)
        },
        "mouseleave": function($event) {
          return _vm.handleBtnMouseEvent(false)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-left align-middle"
    }, [_c('div', {
      staticClass: "cell__text"
    }, [_c('p', [_c('b', [_vm._v("Title: ")]), _vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Description: ")]), _vm._v(_vm._s(item.description))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-left align-middle"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    })])])]] : _vm._e()
  })], 2), _vm._v(" "), _c('table', {
    staticClass: "end-table",
    on: {
      "dragover": function($event) {
        return _vm.changePage(false)
      }
    }
  }, [_vm._m(0)])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af2e481c","hasScoped":true}!./src/components/tasks/tasks.component.html
// module id = 551
// module chunks = 1